import { jsx } from 'react/jsx-runtime';
import { Text } from '@dls/web';
import { SCNoResultsFoundWrapper } from './styles.js';
const NoResultsFound = _ref => {
  let {
    text = "No results found."
  } = _ref;
  return /* @__PURE__ */jsx(SCNoResultsFoundWrapper, {
    "data-testid": "no-results",
    children: /* @__PURE__ */jsx(Text, {
      children: text
    })
  });
};
export { NoResultsFound as default };